import { sprintf } from 'sprintf-js';
const _ = importLib('lodash');
const M = importLib('moment');
const Vuex = importLib('vuex');
const getHelpers = importLib('getHelpers');

const api = getHelpers('api');
const getImagePath = getHelpers('getImagePath');
const getAssetPath = getHelpers('getAssetPath');
const formatString = getHelpers('formatString');

_.mixin({
    imgPath: getImagePath,
    filePath: getAssetPath,
    str: formatString,
});

let converter = {
    /// <summary>
    /// Convert inches into millimetres
    /// </summary>
    /// <param name="inches">Amount in inches</param>
    /// <returns>Amount in millimetres</returns>
    in2mm: function ($inches = 0) {
        return $inches * 25.4;
    },

    /// <summary>
    /// Convert pounds per square inch into megapascals
    /// </summary>
    /// <param name="psi">Amount in pounds per square inch</param>
    /// <returns>Amount in megapascals</returns>
    psi2mpa: function ($psi = 0) {
        return $psi * 0.00689475729;
    },

    /// <summary>
    /// Convert pounds per square inch into megapascals
    /// </summary>
    /// <param name="psi">Amount in pounds per square inch</param>
    /// <returns>Amount in megapascals</returns>
    psi2kpa: function ($psi = 0) {
        return $psi * 6.89475729;
    },

    /// <summary>
    /// Convert feet to metres
    /// </summary>
    /// <param name="ft">Amount in feet</param>
    /// <returns>Amount in metres</returns>
    ft2m: function ($ft = 0) {
        return $ft * 0.3048;
    },

    /// <summary>
    /// Convert inches into metres
    /// </summary>
    /// <param name="inches">Amount in inches</param>
    /// <returns>Amount in metres</returns>
    in2m: function ($inches = 0) {
        return $inches * 0.0254;
    },

    /// <summary>
    /// Convert pounds per square foot into kilopascals
    /// </summary>
    /// <param name="psf">Amount in pounds per square foot</param>
    /// <returns>Amount in kilopascals</returns>
    psf2kpa: function ($psf = 0) {
        return $psf * 0.047880259;
    },

    /// <summary>
    /// Convert millimetres into inches
    /// </summary>
    /// <param name="mm">Amount in millimetres</param>
    /// <returns>Amount in inches</returns>
    mm2in: function ($mm = 0) {
        return $mm * 0.0393700787;
    },

    /// <summary>
    /// Convert megapascals into pounds per square inch
    /// </summary>
    /// <param name="mpa">Amount in megapascals</param>
    /// <returns>Amount in pounds per square inch</returns>
    mpa2psi: function ($mpa = 0) {
        return $mpa * 145.037738;
    },

    /// <summary>
    /// Convert megapascals into pounds per square inch
    /// </summary>
    /// <param name="mpa">Amount in megapascals</param>
    /// <returns>Amount in pounds per square inch</returns>
    kpa2psi: function ($kpa = 0) {
        return $kpa * 0.145037738;
    },

    /// <summary>
    /// Convert metres into feet and inches
    /// </summary>
    /// <param name="m">Amount in metres</param>
    /// <returns>Amoutn in feet and inches</returns>
    m2ftin: function ($m = 0) {
        return $m * 3.2808399; //feet only
    },

    /// <summary>
    /// Convert metres into inches
    /// </summary>
    /// <param name="m">Amount in metres</param>
    /// <returns>Amount in inches</returns>
    m2in: function ($m = 0) {
        return $m * 39.3700787;
    },

    /// <summary>
    /// Convert metres into feet
    /// </summary>
    /// <param name="m">Amount in metres</param>
    /// <returns>Amount in feet</returns>
    m2ft: function ($m = 0) {
        return $m * 3.28084;
    },

    /// <summary>
    /// Convert kilopascals into pounds per square foot
    /// </summary>
    /// <param name="kpa">Amount in kilopascals</param>
    /// <returns>Amount in pounds per square foot</returns>
    kpa2psf: function ($kpa = 0) {
        return $kpa * 20.8854342;
    },

    /// <summary>
    /// Convert kilonewtons into pounds
    /// </summary>
    /// <param name="kn">Amount in kilonewtons</param>
    /// <returns>Amount in pounds</returns>
    kn2lbs: function ($kn = 0) {
        return $kn * 224.808943;
    },

    /// <summary>
    /// Convert millimetres to the power of 4 into inches to the power of 4
    /// </summary>
    /// <param name="mm4">Amount in millimetres to the power of 4</param>
    /// <returns>Amount in inches to the power of 4</returns>
    mm42in4: function ($mm4 = 0) {
        return $mm4 * 0.00000240250961;
    },

    /// <summary>
    /// Convert millimetres cubed into inches cubed
    /// </summary>
    /// <param name="mm3">Amount in millimetres cubed</param>
    /// <returns>Amount in inches cubed</returns>
    mm32in3: function ($mm3 = 0) {
        return $mm3 * 0.0000610237441;
    },

    /// <summary>
    /// Convert kilonewton-metres into foot-pounds
    /// </summary>
    /// <param name="knm">Amount in kilonewton-metres</param>
    /// <returns>Amount in foot-pounds</returns>
    knm2ftlbs: function ($knm = 0) {
        return $knm * 737.562149;
    },

    /// <summary>
    /// Convert kilonewtons per square metre into pounds per square foot
    /// </summary>
    /// <param name="nm">Amount in kilonewtons</param>
    /// <returns>Amount in pounds per square foot</returns>
    nm2psf: function ($nm = 0) {
        return $nm * 20.8854342;
    },
}

export default {
    computed: {
        ...Vuex.mapGetters({
            customer: 'customer',
        }),

        loggedIn() {
            return _.get(this.customer, 'attributes.registered');
        },

        _() {
            return _;
        },

        api() {
            return api;
        },

        conv() {
            return converter;
        },
    },

    methods: {
        __(value, format = null) {
            return formatString(value, format);
        },

        randomKey() {
            return Math.floor(Math.random() * 1000000);
        },

        serialize(value) {
            return JSON.stringify(value);
        },

        displayUnitByType(val, trueType, falseType) {
            return val ? trueType : falseType;
        },

        displayDeadLoadDeflection(val, first = false) {
            return this.displayDoubleToDecimalPlace(val, 2);
        },

        displayDoubleToDecimalPlace(val, dec = 2) {
            switch (_.toLower(val)) {
                case 'inf':
                    return Infinity;
                case '-inf':
                    return -Infinity;
                case 'nan':
                    return NaN;
            }

            return parseFloat(val).toFixed(dec);
        },

        displayDoubleToDecimalPlaceNoRound(val, dec = 2) {
            switch (_.toLower(val)) {
                case 'inf':
                    return Infinity;
                case '-inf':
                    return -Infinity;
                case 'nan':
                    return NaN;
            }

            let value = _.parseInt(val * (10 ** dec)) / (10 ** dec);
            return value.toFixed(dec);
        },

        displayFormatByUnit(isMetric, val) {
            if (isMetric) {
                return _.replace(val.toExponential(2), 'e+', 'E+');
            }

            return this.displayDoubleToDecimalPlace(val, 2);
        },

        isElementInViewport(el) {
            var rect = el.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            );
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/site/js/components/UtilsMixin.js